var render = function render(){var _vm=this,_c=_vm._self._c;return _c('be-button',{attrs:{"variant":'apple',"is-full":true,"is-loading":_vm.isLoading},on:{"click":_vm.logIn}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }